import a from "./_isPrototype.js";
import e from "./_nativeKeys.js";
var s = Object.prototype, n = s.hasOwnProperty;
function f(r) {
  if (!a(r))
    return e(r);
  var o = [];
  for (var t in Object(r))
    n.call(r, t) && t != "constructor" && o.push(t);
  return o;
}
export {
  f as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_baseKeys.js
// module id = 1436
// module chunks = 41